//#region src/utils/arrayHas.ts
function arrayHas(arr) {
	const set = new Set(arr);
	return (value) => set.has(value);
}
//#endregion
export { arrayHas };
